import ChevronRightIcon from "@atlaskit/icon/core/chevron-right";
import DownloadIcon from "@atlaskit/icon/core/download";
import {token} from "@atlaskit/tokens";
import {AnankeDropdownItem} from "@vesta/ananke/components/anankeDropdownItem";

type ExportFlatDropdownItemsProps = {
    /** Omit to retire/hide CSV while preserving independent PDF export. */
    onExportCsv?: () => void;
    /** Omit to hide PDF. */
    onExportPdf?: () => void;
};

function ExportFlatDropdownItem({
    label,
    onClick,
}: {
    label: string;
    onClick: () => void;
}) {
    return (
        <AnankeDropdownItem
            onClick={onClick}
            elemBefore={<DownloadIcon label="" color={token("color.icon")} />}
            elemAfter={<ChevronRightIcon label="" size="small" color={token("color.icon.subtle")} />}
        >
            {label}
        </AnankeDropdownItem>
    );
}

/** Amaron desktop ⋯ menu — flat CSV / PDF rows with download icon and chevron (no nested Export submenu). */
export function ExportFlatDropdownItems({onExportCsv, onExportPdf}: ExportFlatDropdownItemsProps) {
    return (
        <>
            {onExportCsv !== undefined ? (
                <ExportFlatDropdownItem
                    label="Export as CSV"
                    onClick={onExportCsv}
                />
            ) : null}
            {onExportPdf !== undefined ? (
                <ExportFlatDropdownItem label="Export as PDF" onClick={onExportPdf} />
            ) : null}
        </>
    );
}
